import Button from "ds/components/Button";
import Tooltip from "ds/components/Tooltip";

type FormSaveButtonProps = {
  onPress: () => void;
  isDirty: boolean;
  loading: boolean;
};

const FormSaveButton = ({ onPress, isDirty, loading }: FormSaveButtonProps) => {
  return (
    <Tooltip
      active={!isDirty}
      widthMode="maxWidthXSm"
      on={(props) => (
        <Button
          {...props}
          variant="primary"
          onPress={onPress}
          loading={loading}
          ariaDisabled={!isDirty}
        >
          Save
        </Button>
      )}
    >
      No changes to save
    </Tooltip>
  );
};

export default FormSaveButton;
